import { Link, Outlet } from 'react-router-dom';
import {
  Navbar,
  NavbarItem,
  NavbarLabel,
  NavbarSection,
  NavbarSpacer,
} from '../ui/navbar';
import UserMenu from '../auth/UserMenu';
import { hasRole, useAuth } from '../auth/AuthProvider';
import Logo from '../components/Logo';

function HeaderNav() {
  const { groups } = useAuth();
  const showAdmin = hasRole(groups, 'admin', 'team-admin', 'scorekeeper');
  return (
    <Navbar>
      <NavbarItem href="/" aria-label="Home">
        <NavbarLabel>
          <Logo />
        </NavbarLabel>
      </NavbarItem>
      <NavbarSpacer />
      <NavbarSection>
        <NavbarItem href="/teams">Teams</NavbarItem>
        <NavbarItem href="/me" className="hidden min-[430px]:block">My hub</NavbarItem>
        {showAdmin ? (
          <NavbarItem href="/admin" className="hidden min-[380px]:block">
            Admin
          </NavbarItem>
        ) : null}
        <UserMenu />
      </NavbarSection>
    </Navbar>
  );
}

export default function PublicLayout() {
  return (
    <div className="flex min-h-svh flex-col bg-zinc-950 text-zinc-100">
      <header className="border-b border-zinc-800 px-4 sm:px-6">
        <HeaderNav />
      </header>

      <main className="mx-auto w-full max-w-6xl flex-1 px-6 py-8">
        <Outlet />
      </main>

      <footer className="border-t border-zinc-800 px-4 py-8 text-sm text-zinc-400 sm:px-6">
        <div className="mx-auto grid max-w-6xl gap-8 sm:grid-cols-[1fr_auto_auto]">
          <div className="max-w-sm">
            <Logo className="text-zinc-100" />
            <p className="mt-3">
              Live youth baseball, score updates, replays, and family access from anywhere.
            </p>
          </div>

          <nav aria-label="Watch" className="space-y-2">
            <div className="font-medium text-zinc-100">Watch</div>
            <Link to="/teams" className="block hover:text-zinc-100">
              Teams
            </Link>
            <Link to="/signup" className="block hover:text-zinc-100">
              Create account
            </Link>
            <Link to="/login" className="block hover:text-zinc-100">
              Sign in
            </Link>
          </nav>

          <nav aria-label="Manage" className="space-y-2">
            <div className="font-medium text-zinc-100">Manage</div>
            <Link to="/admin" className="block hover:text-zinc-100">
              Admin
            </Link>
            <Link to="/admin/teams" className="block hover:text-zinc-100">
              Teams dashboard
            </Link>
          </nav>
        </div>

        <div className="mx-auto mt-8 flex max-w-6xl flex-col gap-2 border-t border-zinc-800 pt-4 text-xs text-zinc-500 sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} BaseballSTRM.</span>
          <span>Built for game-day streaming and family replay.</span>
        </div>
      </footer>
    </div>
  );
}
